import { X } from 'lucide-react';

import { useToast } from '../contexts/ToastContext';
import ChannelIcon from './ChannelIcon';

export default function ToastContainer() {
  const { toasts, dismissToast } = useToast();

  if (toasts.length === 0) return null;

  return (
    <div className="toast-container" aria-live="polite">
      {toasts.map((toast) => (
        <div key={toast.id} className="toast">
          <div className="toast-header">
            <span className="toast-label">{toast.label}</span>
            <button
              type="button"
              className="toast-close"
              onClick={() => dismissToast(toast.id)}
              aria-label="Dismiss"
            >
              <X size={14} />
            </button>
          </div>
          <div className="toast-body">
            {toast.channelCode && (
              <span className="toast-channel-icon">
                <ChannelIcon code={toast.channelCode} />
              </span>
            )}
            <span className="toast-title">{toast.title}</span>
          </div>
        </div>
      ))}
    </div>
  );
}
